import React, { useState } from 'react';
import Modal from 'components/new_ui/Modal/Modal';

import { Button } from 'react-bootstrap5';

import actions from 'components/Members/RequiredActions/ReturnToWorkFirstSession/Actions';

export default function Index() {
  const [show, setShow] = useState(true);
  const [openVideo, setOpenVideo] = useState(false);

  const closeForm = () => setShow(false);

  const closeRequiredAction = (callback) => {
    actions.skip('assessment_debrief', () => {
      closeForm();
      callback();
    });
  };

  const onSkipClick = () => {
    closeRequiredAction(() => {});
  };

  const onStartClick = () => {
    closeRequiredAction(() => {
      setOpenVideo(true);
    });
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={closeForm}
      onExited={() => {
        if (openVideo) {
          setTimeout(() => {
            const event = new CustomEvent('ReturnToWorkFirstAiSession', {
              detail: {
                // welcomeMessage: `Hi <name>, welcome to your Health and Performance Assessment debrief.
                // I’m here to help you understand your results and develop an action plan.
                // Ready to explore your assessment insights?`,
                welcomeMessage: `Please introduce yourself with your name and role. 
                Review my Talent Assessment results and provide a brief, motivational 
                introduction. Highlight my key strengths and growth areas using percentile 
                scores in a conversational way. Make connections between different 
                leadership dimensions and suggest one area where I could focus my 
                development efforts. Use an encouraging tone and coaching style that 
                empowers me to take action on my leadership journey.`,
                isAiDebrief: true,
              },
            });
            window.dispatchEvent(event);
          }, 1000);
        }
      }}
    >
      <h2>AI-Assisted Leadership Debrief</h2>

      <h3>Personalized Leadership Insights</h3>
      <p>
        The AI-Assisted Leadership Debrief provides a guided exploration of your
        assessment results. During this interactive session, you&apos;ll:
      </p>
      <ul>
        <li>Gain deeper insights into your leadership preferences and patterns</li>
        <li>Understand how your style impacts team dynamics and organizational outcomes</li>
        <li>Identify specific development opportunities aligned with your career goals</li>
        <li>Receive customized resource recommendations based on your profile</li>
        <li>Receive personalized resources matched to your needs</li>
      </ul>
      <h3>What to Expect</h3>
      <p>
        Our AI Coach uses advanced conversational intelligence to facilitate
        meaningful reflection while maintaining complete confidentiality.
        Come prepared to discuss your leadership aspirations and challenges.
      </p>

      <footer className="d-flex justify-content-between">
        <Button
          onClick={onSkipClick}
          variant="link"
        >
          Skip
        </Button>
        <Button onClick={onStartClick}>
          Start Now
        </Button>
      </footer>
    </Modal>
  );
}
